export default __webpack_public_path__ + "images/plot-type-geo-heat.88c9ffba1162cfccfdd9f6a3efc43647.svg";